// extracted by mini-css-extract-plugin
export var label = "_dk-5";
export var slideContainer = "_dk-0";
export var slider = "_dk-1";
export var sliderLg = "_dk-4";
export var sliderMd = "_dk-3";
export var sliderSm = "_dk-2";